import Transforms from './transforms'

const endpoints = {
    list: {
        path: '/imports',
        transform: Transforms.list,
    },
    create: {
        method: 'POST',
        path: '/imports',
        transform: Transforms.create,
    },
    get: {
        path: '/imports/:id',
        transform: Transforms.get,
    },
    remove: {
        method: 'DELETE',
        path: '/imports/:id',
    },
    update: {
        method: 'PUT',
        path: '/imports/:id',
    },
    save: {
        method: 'PUT',
        path: '/imports/:id/confirm',
        transform: Transforms.create,
    },
    cancel: {
        method: 'PUT',
        path: '/imports/:id/cancel',
    },
    getSource: {
        path: '/imports/:id/source',
        transform: Transforms.getSource,
    },
    editSource: {
        method: 'PUT',
        path: '/imports/:id/source',
        transform: Transforms.editSource,
    },
    deleteSource: {
        method: 'DELETE',
        path: '/imports/:id/source',
    },
    files: {
        method: 'POST',
        path: '/imports/files',
    },
}

export default {
    name: 'imports',
    endpoints,
}
